// Generated from docs/ux/TOKENS.json by `pnpm tokens:gen` (codegen lives at
// scripts/tokens-gen.mjs). Do NOT edit by hand: changes will be overwritten.
//
// Source of truth: docs/ux/TOKENS.json (RFC-104 design-system bridge).

export const tokens = {
  color: {
    surface: {
      0: "#0E1512",
      1: "#141D19",
      2: "#1A2521",
      3: "#243330"
    },
    ink: {
      primary: "#E1E8E5",
      secondary: "#BFC9C5",
      muted: "#899490",
      inverse: "#0E1512"
    },
    accent: {
      primary: "#4FE2B0",
      strong: "#005E42",
      subtle: "#003828",
      on: "#003828"
    },
    semantic: {
      success: "#4FE2B0",
      warning: "#FFB068",
      danger: "#FF897A",
      info: "#8AB4FF"
    },
    overlay: {
      scrim: "rgba(0,0,0,0.6)",
      tooltip: "rgba(14,21,18,0.95)"
    },
    engine: {
      maplibre: "#3a8bff",
      deckgl: "#a78bfa",
      cesium: "#3ddc97",
      three: "#ffb547"
    },
    canvas: {
      light: "#F5F7F6",
      threeDNeutral: null
    },
    environment: {
      sky: {
        clear: "#87CEEB",
        overcast: "#B0C4CF",
        dusk: "#D4603A",
        night: "#060D18"
      },
      sun: {
        warm: "#FFD59E",
        neutral: "#FFF8E7",
        cool: "#D6E8FF"
      },
      moon: {
        cool: "#8899BB",
        neutral: "#FFFDE7"
      },
      fog: {
        neutral: "#C8D8E8",
        warm: "#E8C8A0",
        cool: "#6A7FA8"
      },
      night: {
        tint: "#0A1628"
      },
      lightning: {
        flash: "#FFFFF5"
      },
      rain: {
        tint: "#7A9DB5"
      },
      snow: {
        tint: "#E4EDF8"
      }
    }
  },
  space: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 24,
    6: 32,
    7: 48,
    8: 64
  },
  radius: {
    sm: 4,
    md: 8,
    lg: 12,
    pill: 999,
    chip: 4,
    input: 8
  },
  font: {
    family: {
      ui: "Inter, system-ui, sans-serif",
      mono: "JetBrains Mono, Menlo, monospace"
    },
    size: {
      xs: 11,
      sm: 13,
      md: 15,
      lg: 18,
      xl: 22,
      '2xl': 28
    },
    weight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.45,
      loose: 1.7
    },
    role: {
      body: {
        size: 14,
        lineHeight: 1.45,
        weight: 400
      },
      label: {
        size: 12,
        lineHeight: 1.2,
        weight: 500
      },
      engMeta: {
        size: 11,
        lineHeight: 1.3,
        weight: 400
      },
      engMono: {
        size: 12,
        lineHeight: 1.3,
        weight: 400,
        family: "mono"
      },
      engRow: {
        size: 13,
        lineHeight: 1.3,
        weight: 400
      },
      engTag: {
        size: 13,
        lineHeight: 1.3,
        weight: 500,
        family: "mono"
      },
      canvasMeta: {
        size: 12,
        lineHeight: 1.2,
        weight: 400
      }
    }
  },
  motion: {
    duration: {
      instant: 0,
      fast: 120,
      normal: 200,
      slow: 320,
      scrub: 8,
      confirmRevert: 2000,
      presetTransition: 400,
      lightningFlash: 250,
      particleFade: 600,
      masterToggleDispose: 1000
    },
    easing: {
      standard: "cubic-bezier(0.2, 0, 0, 1)",
      decel: "cubic-bezier(0, 0, 0.2, 1)",
      accel: "cubic-bezier(0.4, 0, 1, 1)"
    },
    reducedMotion: {
      duration: 0
    }
  },
  elevation: {
    0: "none",
    1: "0 1px 2px rgba(0,0,0,0.4)",
    2: "0 4px 12px rgba(0,0,0,0.5)",
    3: "0 12px 32px rgba(0,0,0,0.6)"
  },
  zIndex: {
    base: 0,
    panel: 10,
    dock: 20,
    tooltip: 30,
    modal: 40,
    toast: 50
  },
  breakpoint: {
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1440
  },
  layout: {
    leftRail: 192,
    rightPanel: 320,
    collapsedRail: 24,
    authCard: 420,
    popoverXs: 240,
    popoverSm: 280,
    popoverMd: 320,
    popoverLg: 360,
    panelMd: 320,
    settingsRail: 240,
    standaloneStateNarrow: 480,
    standaloneStateWide: 560,
    standaloneStateExtraWide: 720,
    workspaceCanvasInset: 16,
    timelineFooterHeight: 48,
    profileToolbarHeight: 40,
    bottomBarHeight: 48
  },
  width: {
    authCard: 420,
    popoverXs: 240,
    popoverSm: 280,
    popoverMd: 320,
    popoverLg: 360,
    panelMd: 320
  },
  size: {
    meterBar: 2,
    switchMinWidth: 32,
    switchMinHeight: 20,
    dropdownMaxHeight: 480
  },
  border: {
    thin: "1px solid var(--md-outline-variant, #3F4F4A)",
    width: {
      thin: 1
    }
  },
  density: {
    touchMin: 40,
    rowDense: 32,
    rowDefault: 40,
    rowComfy: 48
  },
  focus: {
    ringWidth: 2,
    ringOffset: 2,
    ringColor: "var(--md-primary, #4FE2B0)"
  },
  visuallyHidden: {
    size: 1
  }
} as const;

export type Tokens = typeof tokens;
export type ColorToken = keyof typeof tokens.color;
export type SpaceToken = keyof typeof tokens.space;
export type RadiusToken = keyof typeof tokens.radius;
export type SemanticColor = keyof typeof tokens.color.semantic;
export type SurfaceLevel = keyof typeof tokens.color.surface;
export type FontSize = keyof typeof tokens.font.size;
export type ZIndex = keyof typeof tokens.zIndex;
export type LayoutToken = keyof typeof tokens.layout;
export type WidthToken = keyof typeof tokens.width;
export type DensityToken = keyof typeof tokens.density;
export type SizeToken = keyof typeof tokens.size;
export type FontRoleToken = keyof typeof tokens.font.role;
